"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InterceptorList = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data Structure for creating request and response "interceptor" (or event) pipeline.
 */
var InterceptorList = function InterceptorList() {
  _classCallCheck(this, InterceptorList);

  this.request = new Interceptor();
  this.response = new Interceptor();
};
/**
 * A tool for managing and iterating items in a pipeline.
 */


exports.InterceptorList = InterceptorList;

var Interceptor =
/*#__PURE__*/
function () {
  function Interceptor() {
    _classCallCheck(this, Interceptor);

    this._handlers = [];
  }
  /**
   * Install success and failure handlers into the pipe
   * @param onSuccess
   * @param onError
   * @returns {number} - the ID of the interceptor. Use to eject it from the pipeline.
   */


  _createClass(Interceptor, [{
    key: "use",
    value: function use(onSuccess, onError) {
      this._handlers.push({
        onSuccess: onSuccess,
        onError: onError
      });

      return this._handlers.length - 1;
    }
    /**
     * Removes an interceptor from the pipe.
     * @param id
     */

  }, {
    key: "eject",
    value: function eject(id) {
      if (this._handlers[id]) {
        this._handlers[id] = null;
      }
    }
    /**
     * Walk the list of registered handlers.
     * @param fn - callback that receives each item in the list.
     */

  }, {
    key: "forEach",
    value: function forEach(fn) {
      this._handlers.filter(function (h) {
        return !!h;
      }).forEach(function (h) {
        return fn(h);
      });
    }
  }]);

  return Interceptor;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/core/InterceptorList.js
// module id = 253
// module chunks = 0